import React, { useContext, useEffect } from "react";
import { App, ConfigProvider } from "antd";
import { createRoot } from "react-dom/client";
import MarcaList from "./MarcaList";
import FormMarca from "./FormMarca";
import useMain from "./useMain";
import { EditableContextProvider } from "../../common/EditableContextProvider";
import rubros from './marcas.json';

export const Main = ({ managed }) => {
    const context = useMain();

    useEffect(() => {
        Promise.all([
            context.fillItems(),
        ]);
    }, []);

    const rubroHandleChange = (e) => {
        context.setRubro(e.target.value);
        context.fillItems(1, e.target.value)
    }

    return (
        <EditableContextProvider data={{ context }}>
            <div>
                <div className="col-md-8 mx-auto my-4 text-center">
                    <p className="h3 fw-bold">
                        Marcas
                    </p>
                </div>

                <div className="row">
                    <div className="col"></div>
                    <div className="col-md-5">
                        <div className="row">
                            <div className="col-md-auto">
                                <label className="col-form-label fw-bold" >Rubro:</label>
                            </div>
                            <div className="col-md">
                                <select name="rubro" className="form-select"
                                    onChange={rubroHandleChange}
                                >
                                    <option value="todos">-- Todos --</option>
                                    {
                                        rubros.map((rubro) => (
                                            <option key={rubro.id} value={rubro.nombre}>{rubro.nombre}</option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col"></div>
                </div>

                <div className="col-md-9 mx-auto">
                    { (managed === 'true')? (
                        <button className="btn btn-sm btn-dark" onClick={() => context.form.show()}>
                            Agregar Nuevo
                        </button>
                    ) : '' }
                </div>
                <MarcaList items={context.items} managed={managed} />

                <FormMarca />
            </div>
        </EditableContextProvider>
    );
}

const main = document.getElementById('marcas-main');
const data = main?.dataset;

if (main) {
    if (!main.root) { main.root = createRoot(main); }
    main.root.render(
        <React.StrictMode>
            <ConfigProvider theme={{
                token: {
                    fontFamily: 'Poppins',
                    colorPrimary: 'rgb(11, 183, 131)'
                }
            }}>
                <App>
                    <Main managed={data.managed} />
                </App>
            </ConfigProvider>
        </React.StrictMode>
    );
}
